import ufeApi from 'services/api/ufeApi';
import headerUtils from 'utils/Headers';
import servicesUtils from 'utils/Services';
import userUtils from 'utils/User';

const { userXTimestampHeader } = headerUtils;
const { appendIOSSafariCacheBustingParam } = servicesUtils;

// https://jira.sephora.com/wiki/display/ILLUMINATE/Add+to+Cart+API

function addToCart({ orderId, skuList, fulfillmentType = null }, includeAllBasketItems) {
    const url = appendIOSSafariCacheBustingParam(`/api/shopping-cart/basket/items${includeAllBasketItems ? '?includeAllBasketItems=true' : ''}`);

    const body = {
        orderId,
        skuList
    };

    if (fulfillmentType) {
        body.fulfillmentType = fulfillmentType;
    }

    const headers = userXTimestampHeader();

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers: userUtils.insertSAZipCodeSACountryCodeHeaders(headers),
            body: JSON.stringify(body)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default addToCart;
